<ng-container *ngIf="!showEmptyState; else emptyState">
  <figure class="highcharts-figure">
    <div id="{{selector}}{{parent}}" class="highcharts-height-30"></div>
  </figure>
</ng-container>

<ng-template #emptyState><app-empty-chart></app-empty-chart></ng-template>
